import { type ComponentPropsWithoutRef, type FunctionComponent } from "react";
import AdjustmentsHorizontalIcon from "shared/components/icons/AdjustmentsHorizontalIcon";
import AlertTriangleIcon from "shared/components/icons/AlertTriangleIcon";
import ArrowLeftIcon from "shared/components/icons/arrow/ArrowLeftIcon";
import ArrowPathIcon from "shared/components/icons/arrow/ArrowPathIcon";
import ArrowsMaximizeIcon from "shared/components/icons/arrow/ArrowsMaximizeIcon";
import ArrowsSplitIcon from "shared/components/icons/arrow/ArrowsSplitIcon";
import BellIcon from "shared/components/icons/BellIcon";
import BookIcon from "shared/components/icons/book/BookIcon";
import BookMarkIcon from "shared/components/icons/book/BookMarkIcon";
import BookmarkSquareIcon from "shared/components/icons/book/BookmarkSquareIcon";
import BookOutlineIcon from "shared/components/icons/book/BookOutlineIcon";
import BoxMultipleIcon from "shared/components/icons/BoxMultipleIcon";
import BriefcaseIcon from "shared/components/icons/BriefcaseIcon";
import BuildingIcon from "shared/components/icons/BuildingIcon";
import CalendarDaysIcon from "shared/components/icons/calendar/CalendarDaysIcon";
import CalendarEventIcon from "shared/components/icons/calendar/CalendarEventIcon";
import CalendarIcon from "shared/components/icons/calendar/CalendarIcon";
import CalendarIconWithPlusIcon from "shared/components/icons/calendar/CalendarIconWithPlusIcon";
import AmexIcon from "shared/components/icons/cardType/AmexIcon";
import GenericIcon from "shared/components/icons/cardType/GenericIcon";
import MasterCardIcon from "shared/components/icons/cardType/MasterCardIcon";
import VisaIcon from "shared/components/icons/cardType/VisaIcon";
import CaretLeftIcon from "shared/components/icons/caret/CaretLeftIcon";
import CaretRightIcon from "shared/components/icons/caret/CaretRightIcon";
import CashOutlineIcon from "shared/components/icons/CashOutlineIcon";
import CertificateIcon from "shared/components/icons/CertificateIcon";
import ChartArrowsIcon from "shared/components/icons/chart/ChartArrowsIcon";
import ChartBarSquareIcon from "shared/components/icons/chart/ChartBarSquareIcon";
import ChartHistogramIcon from "shared/components/icons/chart/ChartHistogramIcon";
import ChartPieIcon from "shared/components/icons/chart/ChartPieIcon";
import ChatBubbleIcon from "shared/components/icons/chat/ChatBubbleIcon";
import ChatBubbleLeftIcon from "shared/components/icons/chat/ChatBubbleLeftIcon";
import ChatBubbleOvalLeftIcon from "shared/components/icons/chat/ChatBubbleOvalLeftIcon";
import ChatBubblesOutlineIcon from "shared/components/icons/chat/ChatBubblesOutlineIcon";
import CheckCircleIcon from "shared/components/icons/check/CheckCircleIcon";
import ChevronBackIcon from "shared/components/icons/chevron/ChevronBackIcon";
import ChevronDownIcon from "shared/components/icons/chevron/ChevronDownIcon";
import ChevronExpandOutlineIcon from "shared/components/icons/chevron/ChevronExpandOutlineIcon";
import ChevronLeftIcon from "shared/components/icons/chevron/ChevronLeftIcon";
import ChevronRightIcon from "shared/components/icons/chevron/ChevronRightIcon";
import ChevronsLeftIcon from "shared/components/icons/chevron/ChevronsLeftIcon";
import ChevronsRightIcon from "shared/components/icons/chevron/ChevronsRightIcon";
import ChevronUpDownIcon from "shared/components/icons/chevron/ChevronUpDownIcon";
import ChevronUpIcon from "shared/components/icons/chevron/ChevronUpIcon";
import CircleSquareIcon from "shared/components/icons/CircleSquareIcon";
import ClipboardCheckIcon from "shared/components/icons/clipboard/ClipboardCheckIcon";
import ClipboardIcon from "shared/components/icons/clipboard/ClipboardIcon";
import ClipboardPlusIcon from "shared/components/icons/clipboard/ClipboardPlusIcon";
import ClockIcon from "shared/components/icons/ClockIcon";
import CloudDownloadIcon from "shared/components/icons/cloud/CloudDownloadIcon";
import CloudDownloadOutlineIcon from "shared/components/icons/cloud/CloudDownloadOutlineIcon";
import CloudUploadOutlineIcon from "shared/components/icons/cloud/CloudUploadOutlineIcon";
import CodeIcon from "shared/components/icons/CodeIcon";
import CoinIcon from "shared/components/icons/CoinIcon";
import ColumnsThreeIcon from "shared/components/icons/ColumnsThreeIcon";
import CopyIcon from "shared/components/icons/CopyIcon";
import CreditCardIcon from "shared/components/icons/CreditCardIcon";
import DocumentOutlineIcon from "shared/components/icons/DocumentOutlineIcon";
import DotIcon from "shared/components/icons/dot/DotIcon";
import DotsEllipsisIcon from "shared/components/icons/dot/DotsEllipsisIcon";
import DotsVerticalIcon from "shared/components/icons/dot/DotsVerticalIcon";
import DownloadIcon from "shared/components/icons/DownloadIcon";
import EaselOutlineIcon from "shared/components/icons/EaselOutlineIcon";
import EnvelopeFilledIcon from "shared/components/icons/EnvelopeFilledIcon";
import EraserIcon from "shared/components/icons/EraserIcon";
import ExternalLinkIcon from "shared/components/icons/ExternalLinkIcon";
import EyeIcon from "shared/components/icons/eye/EyeIcon";
import EyeOffIcon from "shared/components/icons/eye/EyeOffIcon";
import FileDollarIcon from "shared/components/icons/file/FileDollarIcon";
import FileDownloadIcon from "shared/components/icons/file/FileDownloadIcon";
import FileExportIcon from "shared/components/icons/file/FileExportIcon";
import FileReportIcon from "shared/components/icons/file/FileReportIcon";
import FileSymlinkIcon from "shared/components/icons/file/FileSymlinkIcon";
import FileTextIcon from "shared/components/icons/file/FileTextIcon";
import FileTrayFullOutlineIcon from "shared/components/icons/file/FileTrayFullOutlineIcon";
import FileTrayOutlineIcon from "shared/components/icons/file/FileTrayOutlineIcon";
import FileTrayStackedOutlineIcon from "shared/components/icons/file/FileTrayStackedOutlineIcon";
import FolderOpenOutlineIcon from "shared/components/icons/FolderOpenOutlineIcon";
import GavelIcon from "shared/components/icons/GavelIcon";
import GitForkIcon from "shared/components/icons/GitForkIcon";
import GripVerticalIcon from "shared/components/icons/GripVerticalIcon";
import HandThumbUpIcon from "shared/components/icons/HandThumbUpIcon";
import HeadphonesFilledIcon from "shared/components/icons/HeadphonesFilledIcon";
import IdCardOutlineIcon from "shared/components/icons/IdCardOutlineIcon";
import ImpersonateIcon from "shared/components/icons/ImpersonateIcon";
import InfoIcon from "shared/components/icons/InfoIcon";
import LayoutColumnsIcon from "shared/components/icons/layout/LayoutColumnsIcon";
import LayoutSidebarLeftExpandIcon from "shared/components/icons/layout/LayoutSidebarLeftExpandIcon";
import LayoutSidebarRightExpandIcon from "shared/components/icons/layout/LayoutSidebarRightExpandIcon";
import LinkIcon from "shared/components/icons/LinkIcon";
import ListIcon from "shared/components/icons/list/ListIcon";
import ListOutlineIcon from "shared/components/icons/list/ListOutlineIcon";
import LockClosedIcon from "shared/components/icons/lock/LockClosedIcon";
import LockIcon from "shared/components/icons/lock/LockIcon";
import LockOpenIcon from "shared/components/icons/lock/LockOpenIcon";
import LogOutOutlineIcon from "shared/components/icons/LogOutOutlineIcon";
import MailForwardIcon from "shared/components/icons/mail/MailForwardIcon";
import MailOutlineIcon from "shared/components/icons/mail/MailOutlineIcon";
import MergeIcon from "shared/components/icons/MergeIcon";
import PencilEditIcon from "shared/components/icons/pencil/PencilEditIcon";
import PencilIcon from "shared/components/icons/pencil/PencilIcon";
import PencilSquareIcon from "shared/components/icons/pencil/PencilSquareIcon";
import PeopleOutlineIcon from "shared/components/icons/PeopleOutlineIcon";
import PhotoIcon from "shared/components/icons/PhotoIcon";
import { type PillarIconName } from "shared/components/icons/pillarIconNames";
import PinIcon from "shared/components/icons/pin/PinIcon";
import PinnedIcon from "shared/components/icons/pin/PinnedIcon";
import PinnedOffIcon from "shared/components/icons/pin/PinnedOffIcon";
import PlusIcon from "shared/components/icons/PlusIcon";
import PresentationIcon from "shared/components/icons/PresentationIcon";
import ReceiptOffIcon from "shared/components/icons/receipt/ReceiptOffIcon";
import ReceiptTaxIcon from "shared/components/icons/receipt/ReceiptTaxIcon";
import ReportsIcon from "shared/components/icons/ReportsIcon";
import RibbonOutlineIcon from "shared/components/icons/RibbonOutlineIcon";
import RobotIcon from "shared/components/icons/RobotIcon";
import RotateClockwiseIcon from "shared/components/icons/RotateClockwiseIcon";
import SchoolIcon from "shared/components/icons/SchoolIcon";
import ScissorsIcon from "shared/components/icons/ScissorsIcon";
import SearchIcon from "shared/components/icons/SearchIcon";
import SendIcon from "shared/components/icons/SendIcon";
import SettingsGearIcon from "shared/components/icons/SettingsGearIcon";
import CheckIcon from "shared/components/icons/sign/CheckIcon";
import CrossCircleFilledIcon from "shared/components/icons/sign/CrossCircleFilledIcon";
import CrossIcon from "shared/components/icons/sign/CrossIcon";
import ExclamationCircleIcon from "shared/components/icons/sign/ExclamationCircleIcon";
import MinusCircleIcon from "shared/components/icons/sign/MinusCircleIcon";
import MinusIcon from "shared/components/icons/sign/MinusIcon";
import SignPlusIcon from "shared/components/icons/sign/PlusIcon";
import PlusSquareIcon from "shared/components/icons/sign/PlusSquareIcon";
import SparklesIcon from "shared/components/icons/SparklesIcon";
import Stack2Icon from "shared/components/icons/Stack2Icon";
import StarIcon from "shared/components/icons/StarIcon";
import TagIcon from "shared/components/icons/TagIcon";
import ThumbDownIcon from "shared/components/icons/thumb/ThumbDownIcon";
import ThumbUpIcon from "shared/components/icons/thumb/ThumbUpIcon";
import TodayOutlineIcon from "shared/components/icons/TodayOutlineIcon";
import TrashFilledIcon from "shared/components/icons/trash/TrashFilledIcon";
import TrashIcon from "shared/components/icons/trash/TrashIcon";
import TrashOutlineIcon from "shared/components/icons/trash/TrashOutlineIcon";
import UserCircleIcon from "shared/components/icons/user/UserCircleIcon";
import UserIcon from "shared/components/icons/user/UserIcon";
import UserMinusIcon from "shared/components/icons/user/UserMinusIcon";
import UserPasswordIcon from "shared/components/icons/user/UserPasswordIcon";
import UserPlusIcon from "shared/components/icons/user/UserPlusIcon";
import UsersIcon from "shared/components/icons/user/UsersIcon";
import VideoCameraIcon from "shared/components/icons/VideoCameraIcon";

export type PillarIconComponent = FunctionComponent<
  ComponentPropsWithoutRef<"svg">
>;

/**
 * Every icon component, keyed by its {@link PillarIconName}. The `satisfies`
 * clause is what ties the two files together: an entry here without a matching
 * name in PILLAR_ICON_DESCRIPTIONS — or a described name with no component
 * registered — is a compile error.
 */
export const pillarIconComponents = {
  // Ionicons-style outline glyphs sized for the hub side menu
  bookOutline: BookOutlineIcon,
  cashOutline: CashOutlineIcon,
  chatbubblesOutline: ChatBubblesOutlineIcon,
  easelOutline: EaselOutlineIcon,
  folderOpenOutline: FolderOpenOutlineIcon,
  listOutline: ListOutlineIcon,
  mailOutline: MailOutlineIcon,
  peopleOutline: PeopleOutlineIcon,
  ribbonOutline: RibbonOutlineIcon,
  idCardOutline: IdCardOutlineIcon,
  fileTrayFullOutline: FileTrayFullOutlineIcon,
  todayOutline: TodayOutlineIcon,
  fileTrayStackedOutline: FileTrayStackedOutlineIcon,

  // People
  user: UserIcon,
  userCircle: UserCircleIcon,
  userMinus: UserMinusIcon,
  userPassword: UserPasswordIcon,
  userPlus: UserPlusIcon,
  users: UsersIcon,
  impersonate: ImpersonateIcon,

  // Arrows and movement
  arrowLeft: ArrowLeftIcon,
  arrowPath: ArrowPathIcon,
  arrowsMaximize: ArrowsMaximizeIcon,
  arrowsSplit: ArrowsSplitIcon,
  rotateClockwise: RotateClockwiseIcon,
  merge: MergeIcon,
  gitFork: GitForkIcon,
  externalLink: ExternalLinkIcon,
  logOutOutline: LogOutOutlineIcon,
  download: DownloadIcon,
  send: SendIcon,

  // Chevrons and carets
  chevronBack: ChevronBackIcon,
  chevronDown: ChevronDownIcon,
  chevronExpandOutline: ChevronExpandOutlineIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  chevronUp: ChevronUpIcon,
  chevronUpDown: ChevronUpDownIcon,
  chevronsLeft: ChevronsLeftIcon,
  chevronsRight: ChevronsRightIcon,
  caretLeft: CaretLeftIcon,
  caretRight: CaretRightIcon,

  // Charts and reporting
  chartArrows: ChartArrowsIcon,
  chartBarSquare: ChartBarSquareIcon,
  chartHistogram: ChartHistogramIcon,
  chartPie: ChartPieIcon,
  reports: ReportsIcon,
  presentation: PresentationIcon,

  // Communication
  chatBubble: ChatBubbleIcon,
  chatBubbleLeft: ChatBubbleLeftIcon,
  chatBubbleOvalLeft: ChatBubbleOvalLeftIcon,
  bell: BellIcon,
  envelopeFilled: EnvelopeFilledIcon,
  mailForward: MailForwardIcon,
  headphonesFilled: HeadphonesFilledIcon,

  // Files and documents
  documentOutline: DocumentOutlineIcon,
  fileDollar: FileDollarIcon,
  fileDownload: FileDownloadIcon,
  fileExport: FileExportIcon,
  fileReport: FileReportIcon,
  fileSymlink: FileSymlinkIcon,
  fileText: FileTextIcon,
  fileTrayOutline: FileTrayOutlineIcon,
  clipboard: ClipboardIcon,
  clipboardCheck: ClipboardCheckIcon,
  clipboardPlus: ClipboardPlusIcon,
  copy: CopyIcon,
  photo: PhotoIcon,

  // Books and bookmarks
  book: BookIcon,
  bookMark: BookMarkIcon,
  bookmarkSquare: BookmarkSquareIcon,

  // Calendar and time
  calendar: CalendarIcon,
  calendarDays: CalendarDaysIcon,
  calendarEvent: CalendarEventIcon,
  calendarWithPlus: CalendarIconWithPlusIcon,
  clock: ClockIcon,

  // Money and commerce
  coin: CoinIcon,
  creditCard: CreditCardIcon,
  receiptOff: ReceiptOffIcon,
  receiptTax: ReceiptTaxIcon,
  cardAmex: AmexIcon,
  cardGeneric: GenericIcon,
  cardMasterCard: MasterCardIcon,
  cardVisa: VisaIcon,

  // Status and signs
  check: CheckIcon,
  checkCircle: CheckCircleIcon,
  cross: CrossIcon,
  crossCircleFilled: CrossCircleFilledIcon,
  exclamationCircle: ExclamationCircleIcon,
  alertTriangle: AlertTriangleIcon,
  info: InfoIcon,
  minus: MinusIcon,
  minusCircle: MinusCircleIcon,
  plus: PlusIcon,
  plusSmall: SignPlusIcon,
  plusSquare: PlusSquareIcon,
  sparkles: SparklesIcon,
  star: StarIcon,
  dot: DotIcon,
  dotsEllipsis: DotsEllipsisIcon,
  dotsVertical: DotsVerticalIcon,

  // Visibility and security
  eye: EyeIcon,
  eyeOff: EyeOffIcon,
  lock: LockIcon,
  lockClosed: LockClosedIcon,
  lockOpen: LockOpenIcon,

  // Editing
  pencil: PencilIcon,
  pencilEdit: PencilEditIcon,
  pencilSquare: PencilSquareIcon,
  eraser: EraserIcon,
  scissors: ScissorsIcon,
  trash: TrashIcon,
  trashFilled: TrashFilledIcon,
  trashOutline: TrashOutlineIcon,

  // Layout and structure
  layoutColumns: LayoutColumnsIcon,
  layoutSidebarLeftExpand: LayoutSidebarLeftExpandIcon,
  layoutSidebarRightExpand: LayoutSidebarRightExpandIcon,
  columnsThree: ColumnsThreeIcon,
  list: ListIcon,
  gripVertical: GripVerticalIcon,
  adjustmentsHorizontal: AdjustmentsHorizontalIcon,
  settingsGear: SettingsGearIcon,
  circleSquare: CircleSquareIcon,
  boxMultiple: BoxMultipleIcon,
  stack2: Stack2Icon,

  // Pins and tags
  pin: PinIcon,
  pinned: PinnedIcon,
  pinnedOff: PinnedOffIcon,
  tag: TagIcon,
  link: LinkIcon,

  // Cloud
  cloudDownload: CloudDownloadIcon,
  cloudDownloadOutline: CloudDownloadOutlineIcon,
  cloudUploadOutline: CloudUploadOutlineIcon,

  // Feedback
  thumbUp: ThumbUpIcon,
  thumbDown: ThumbDownIcon,
  handThumbUp: HandThumbUpIcon,

  // Domain-specific
  briefcase: BriefcaseIcon,
  building: BuildingIcon,
  certificate: CertificateIcon,
  gavel: GavelIcon,
  school: SchoolIcon,
  robot: RobotIcon,
  code: CodeIcon,
  videoCamera: VideoCameraIcon,
  search: SearchIcon,
} as const satisfies Record<PillarIconName, PillarIconComponent>;

export type PillarIconProps = ComponentPropsWithoutRef<"svg"> & {
  /**
   * Which icon to render. Statically known icons read better as
   * `<PillarIcon.users />`; this prop is for names that arrive at runtime,
   * such as `AppRouteConfig.icon_name` from the database.
   */
  iconName: PillarIconName;
};

const PillarIconDynamic = ({ iconName, ...svgProps }: PillarIconProps) => {
  // The DB stores icon names as plain text, so a stale or hand-edited value
  // can miss the registry at runtime; rendering nothing beats crashing a menu.
  const IconComponent = pillarIconComponents[iconName] as
    | PillarIconComponent
    | undefined;
  if (!IconComponent) {
    return <></>;
  }

  return <IconComponent {...svgProps} />;
};

/**
 * The one way to render an icon by name:
 *
 *   <PillarIcon.users className="h-3 w-3" />           // statically known
 *   <PillarIcon iconName={route.iconName} />           // from data
 *
 * Both forms accept the same svg props as the underlying components. The names
 * and their descriptions live in `PILLAR_ICON_DESCRIPTIONS`
 * (shared/components/icons/pillarIconNames.ts).
 */
const PillarIcon = Object.assign(PillarIconDynamic, pillarIconComponents);

export default PillarIcon;
